import { Component, HostBinding, Injector, OnInit } from '@angular/core';
import { EventsComponent } from '../events/events.component';

@Component({
	selector: 'preferences-ranking',
	template: `
		<div class="wrapper" *ngIf="control" [ngClass]="{ error: error }">
			<div
				class="input-wrapper"
				[ngClass]="{ disabled: control.disabled }"
				[ngStyle]="{ left: -i * 2 + 2 + 'px' }"
				*ngFor="let option of control.options; let i = index"
			>
				<label>
					<input
						class="preference-ranking-input"
						type="radio"
						gtm-handler
						[attr.gtm]="getGaLabel(control)"
						events="click"
						handlerType="radio"
						[label]="getGaLabel(control)"
						action="RadioButton"
						[attr.aria-label]="control.title"
						[attr.aria-describedby]="name + '_error'"
						[name]="name"
						[(ngModel)]="value"
						[value]="option.value"
						(ngModelChange)="setRankingAnswer(value)"
						[disabled]="control.disabled"
						[attr.name]="name"
						[title]="option.title"
					/>
					<div [attr.aria-label]="control.title" class="styled-button-title">
						<p class="center">{{ option.title }}</p>
					</div>
				</label>
			</div>
		</div>
	`,
	styleUrls: ['./preferences-ranking.component.scss'],
})
export class PreferencesRankingComponent extends EventsComponent implements OnInit {
	@HostBinding('attr.name')
	name = this.control ? this.control.name : '';
	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		let x = this.context;
		this.gaLabel = this.getGaLabel(this.control);
	}

	setRankingAnswer(value) {
		this.setAnswer(value);
	}
}
